import React from "react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";

import { Tooltip, TOOLTIP_TYPES, TOOLTIP_POSITION } from "widgets/feedback";
import { Icon } from "widgets/datadisplay";
import { debounce } from "base/utils";

import { DOWNVOTE, UPVOTE } from "@/common/utils/constant";

import styles from "../../forum/forum.css";

import UpvoteIcon from "@/common/icons/UpvoteBig.svg";
import UpvotedIcon from "@/common/icons/Upvoted.svg";
import DownvoteIcon from "@/common/icons/DownvoteBig.svg";
import DownvotedIcon from "@/common/icons/Downvoted.svg";
import CommentIcon from "../../icons/Comments.svg";
import ViewIcon from "../../icons/Views.svg";

export function TopicActions({
  postVote,
  isUpvoted,
  isDisableVote,
  voteCount,
  isDownvoted,
  setEditorFocus,
  totalComments,
  setShowViewModal,
  topicData
}) {
  const delayPostVote = debounce((option) => {
    postVote(option);
  }, 500);
  return (
    <div className={`${styles.topicActions}`}>
      <div className={`${styles.voteSection}`}>
        <Tooltip
          content={<Trans>Upvote</Trans>}
          type={TOOLTIP_TYPES.SMALL}
          position={TOOLTIP_POSITION.TOP}
        >
          <Icon
            paddingNone={true}
            highlight={false}
            onClick={() => delayPostVote(UPVOTE)}
          >
            {isUpvoted ? (
              <UpvotedIcon className={styles.voteIcon} />
            ) : (
              <UpvoteIcon
                className={`${styles.voteIcon} ${
                  isDisableVote ? styles.disableIcon : styles.up
                }`}
                fill="var(--icon-dark-gray)"
              />
            )}
          </Icon>
        </Tooltip>
        <span>{voteCount || 0}</span>
        <Tooltip
          content={<Trans>Downvote</Trans>}
          type={TOOLTIP_TYPES.SMALL}
          position={TOOLTIP_POSITION.TOP}
        >
          <Icon
            paddingNone={true}
            highlight={false}
            onClick={() => delayPostVote(DOWNVOTE)}
          >
            {isDownvoted ? (
              <DownvotedIcon className={styles.voteIcon} />
            ) : (
              <DownvoteIcon
                className={`${styles.voteIcon} ${
                  isDisableVote ? styles.disableIcon : styles.down
                }`}
                fill="var(--icon-dark-gray)"
              />
            )}
          </Icon>
        </Tooltip>
      </div>
      <Tooltip
        content={<Trans>Replies</Trans>}
        type={TOOLTIP_TYPES.SMALL}
        position={TOOLTIP_POSITION.TOP}
      >
        <Icon
          highlight={false}
          className={styles.actionIcon}
          onClick={() => setEditorFocus(true)}
        >
          <CommentIcon />
          <span className={"smallplus"}>{totalComments || 0}</span>
        </Icon>
      </Tooltip>
      <Tooltip
        content={<Trans>Views</Trans>}
        type={TOOLTIP_TYPES.SMALL}
        position={TOOLTIP_POSITION.TOP}
      >
        <Icon
          highlight={false}
          className={styles.actionIcon}
          onClick={() => {
            if (topicData?.SeenCount) {
              setShowViewModal(true);
            }
          }}
        >
          <ViewIcon />
          <span className={"smallplus"}>{topicData.SeenCount || 0}</span>
        </Icon>
      </Tooltip>
    </div>
  );
}

TopicActions.propTypes = {
  fromDetail: PropTypes.bool,
  isDisableVote: PropTypes.bool,
  isDownvoted: PropTypes.bool,
  isUpvoted: PropTypes.bool,
  onUpdateBookmark: PropTypes.func,
  postVote: PropTypes.func,
  setEditorFocus: PropTypes.func,
  setShowViewModal: PropTypes.func,
  showAddSuccess: PropTypes.bool,
  showRemoveSuccess: PropTypes.bool,
  teamId: PropTypes.string,
  topicData: PropTypes.shape({
    IsBookmarked: PropTypes.bool,
    MediumId: PropTypes.string,
    SeenCount: PropTypes.number,
    _id: PropTypes.string
  }),
  totalComments: PropTypes.number,
  voteCount: PropTypes.number
};
